export default __webpack_public_path__ + "static/media/46.d57953e3.jpeg";